import { axios } from "@axios";
import { useQuery, useMutation } from "react-query";
import {
  ExtractFnReturnType,
  MutationConfig,
  QueryConfig,
} from "../../lib/react-query";

// Rename function param to match the backend's offer ID
export const viewOffers = (offerId: string, params: any): Promise<any> => {
  return axios.get(`/offer/view-offer/${offerId}`, { params });
};

export const createOffer = (payload: {
  lenderId: string;
  title: string;
  loanAmount: string;
  interestRate: string;
  loanDuration: string;
  termsAndConditions: string;
}): Promise<any> => {
  return axios.post("/offer/create-offer", payload);
};

export const updateApplicationStatus = ({
  applicationId,
  borrowerId,
  offerId,
  status,
}: {
  applicationId: string;
  borrowerId: string;
  offerId: string;
  status: string;
}): Promise<any> => {
  return axios.put(`/application/update-application/${applicationId}`, {
    borrowerId,
    offerId,
    status,
  });
};

type QueryFnType = typeof viewOffers;

// Updated to use `offerId` instead of `userId`
export const useViewOffersQuery = ({
  offerId,
  params,
  config,
}: {
  offerId: string;
  params: any;
  config?: QueryConfig<QueryFnType>;
}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ["allOffers", offerId, params],
    queryFn: () => viewOffers(offerId, params),
    select: (res: any) => res.data,
    ...config,
  });
};

type CreateOfferFnType = typeof createOffer;

export const useCreateOfferMutation = (
  config?: MutationConfig<CreateOfferFnType>
) => {
  return useMutation(createOffer, config);
};

export const useUpdateApplicationStatusMutation = (
  config?: MutationConfig<typeof updateApplicationStatus>
) => {
  return useMutation(updateApplicationStatus, config);
};


export const updateOffer = ({
  offerId,
  payload,
}: {
  offerId: string;
  payload: {
    lenderId: string;
    title: string;
    loanAmount: string;
    interestRate: string;
    loanDuration: string;
    termsAndConditions: string;
  };
}): Promise<any> => {
  return axios.put(`/offer/update-offer/${offerId}`, payload);
};

type UpdateOfferFnType = typeof updateOffer;

export const useUpdateOfferMutation = (
  config?: MutationConfig<UpdateOfferFnType>
) => {
  return useMutation(updateOffer, config);
};

export const changeStatus = ({
  offerId,
  status,
}: {
  offerId: string;
  status: string;
}): Promise<any> => {
  return axios.put(`/offer/changeOfferStatus/${offerId}`, { status });
}
type ChangeStatusFnType = typeof changeStatus;
export const useChangeStatusMutation = (
  config?: MutationConfig<ChangeStatusFnType>
) => {
  return useMutation(changeStatus, config);
}